<template>
    <div>
        <w-app
            :title="$t('module.blank_pay_slips')"
            show-total
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <BlankPaySlipFilter v-model="filter"/>
            </template>

            <template v-slot:rightToolbar>
                <calculator-irg></calculator-irg>
                <w-btn-reload :loading="loading" @press="findAll"/>
            </template>

            <template v-slot:content>
                <!--<w-data-table
                    :headers="headers"
                    :items="paySlipStore.paySlips"
                    :loading="loading"
                    :external-items-per-page="5"
                    fixed-header
                    height="250"
                    @itemClick="select"
                >
                    <template v-slot:[`item.workerCode`]="{ item }">
                        <w-chip color="teal" :text="item.workerCode"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-chip color="blue darken-2" :text="item.workerLastName"/>
                    </template>
                    <template v-slot:[`item.workerFirstName`]="{ item }">
                        <w-chip color="blue darken-2" :text="item.workerFirstName"/>
                    </template>
                    <template v-slot:[`item.workerOccupationName`]="{ item }">
                        <w-chip color="purple" :text="item.workerOccupationName"/>
                    </template>
                    <template v-slot:[`item.workerOrganizationalChartName`]="{ item }">
                        <w-chip color="cyan" :text="item.workerOrganizationalChartName"/>
                    </template>
                    <template v-slot:[`item.grille`]="{ item }">
                        <w-chip color="orange" :text="item.grille"/>
                    </template>
                    <template v-slot:[`item.baseCotisable`]="{ item }">
                        {{ priceFormat(item.baseCotisable) }}
                    </template>
                    <template v-slot:[`item.baseImposable`]="{ item }">
                        {{ priceFormat(item.baseImposable) }}
                    </template>
                    <template v-slot:[`item.totalGains`]="{ item }">
                        <w-chip color="teal" :text="priceFormat(item.totalGains)"/>
                    </template>
                    <template v-slot:[`item.totalRetenues`]="{ item }">
                        <w-chip color="red" :text="priceFormat(item.totalRetenues)"/>
                    </template>
                    <template v-slot:[`item.net`]="{ item }">
                        <w-chip color="blue" :text="priceFormat(item.net)"/>
                    </template>
                    <template v-slot:[`item.totalCnas`]="{ item }">
                        {{ priceFormat(item.totalCnas) }}
                    </template>
                    <template v-slot:[`item.masse`]="{ item }">
                        {{ priceFormat(item.masse) }}
                    </template>
                </w-data-table>-->
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="paySlipStore.paySlips"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    hide-default-footer
                    must-sort
                    single-select
                    fixed-header
                    height="250"
                    :multi-sort="false"
                    :loading="loading"
                    dense
                    @click:row="select"
                    :item-class="rowColor"
                >

                    <template v-slot:[`item.workerCode`]="{ item }">
                        <w-chip color="teal" :text="item.workerCode"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-chip color="blue darken-2" :text="item.workerLastName"/>
                    </template>
                    <template v-slot:[`item.workerFirstName`]="{ item }">
                        <w-chip color="blue darken-2" :text="item.workerFirstName"/>
                    </template>
                    <template v-slot:[`item.workerOccupationName`]="{ item }">
                        <w-chip color="purple" :text="item.workerOccupationName"/>
                    </template>
                    <template v-slot:[`item.workerOrganizationalChartName`]="{ item }">
                        <w-chip color="cyan" :text="item.workerOrganizationalChartName"/>
                    </template>
                    <template v-slot:[`item.grille`]="{ item }">
                        <w-chip color="orange" :text="item.grille"/>
                    </template>
                    <template v-slot:[`item.baseCotisable`]="{ item }">
                        {{ priceFormat(item.baseCotisable) }}
                    </template>
                    <template v-slot:[`item.baseImposable`]="{ item }">
                        {{ priceFormat(item.baseImposable) }}
                    </template>
                    <template v-slot:[`item.totalGains`]="{ item }">
                        <w-chip color="teal" :text="priceFormat(item.totalGains)"/>
                    </template>
                    <template v-slot:[`item.totalRetenues`]="{ item }">
                        <w-chip color="red" :text="priceFormat(item.totalRetenues)"/>
                    </template>
                    <template v-slot:[`item.net`]="{ item }">
                        <w-chip color="blue" :text="priceFormat(item.net)"/>
                    </template>
                    <template v-slot:[`item.totalCnas`]="{ item }">
                        {{ priceFormat(item.totalCnas) }}
                    </template>
                    <template v-slot:[`item.masse`]="{ item }">
                        {{ priceFormat(item.masse) }}
                    </template>
                    <template v-slot:footer="{}">
                        <br/>
                        <div class="text-center">
                            <v-row justify="center">
                                <v-col md="6">
                                    <v-pagination
                                        v-model="page"
                                        :length="pageCount"
                                    ></v-pagination>
                                </v-col>
                                <v-col md="2">
                                    <w-enum-select
                                        v-model="itemsPerPage"
                                        :items="paginationListLength"
                                        :label="$t('common.items_per_page')"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </v-data-table>
                <BlankPaySlipDetails :pay-slip="selectedOne"/>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import CalculatorIrg from "@/views/PaySlip/Components/CalculatorIrg.vue";
import BlankPaySlipFilter from "@/views/BlankPaySlip/BlankPaySlipFilter.vue";
import BlankPaySlipDetails from "@/views/BlankPaySlip/BlankPaySlipDetails.vue";
import useSharedMethod from "@/use/SharedMethod";
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {usePaySlipStore} from "@/stores/PaySlip";
import axios from "axios";

export default {
    name: "BlankPaySlips",
    components: {
        BlankPaySlipDetails,
        BlankPaySlipFilter,
        CalculatorIrg
    },
    setup() {
        const {$i18n} = useTools();
        const {priceFormat, transformFilterValues} = useSharedMethod();
        const {
            filter,
            loading,
            page,
            itemsPerPage,
            pageCount,
            paginationListLength,
            total,
            itemColor,
        } = useSharedData();

        const paySlipStore = usePaySlipStore();

        const rightDrawer = ref(false);

        const selected = ref([])
        const headers = ref([]);
        filter.value = {phase: "ACTIVE"};
        itemsPerPage.value = 5;


        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                if (key === 'phase') {
                    filter.value[key] = 'ACTIVE';
                } else {
                    filter.value[key] = null;
                }
            });
        }

        const selectedOne = ref({details: []});

        function findAll(selectedIndex) {
            loading.value = true;
            selectedOne.value = {details: []};
            axios.get(`/payments/paySlip/workers/preview`, {
                params: transformFilterValues(filter.value)
            }).then(response => {
                let id = 1;

                response.data.forEach((item) => {
                    item.id = id;
                    id++;
                })
                paySlipStore.setPaySlips(response.data);
                total.value = response.data.length;

                headers.value = [];
                addHeaderHead();
                addFooterHeader();
                paySlipStore.paySlips.forEach((element) => {
                    element.details.forEach((detail) => {
                        if (detail.printIn !== "5" && detail.value !== 0) {
                            element[detail.code] = priceFormat(detail.value);
                            addHeader(detail);
                        }
                    });
                });


                if (paySlipStore.paySlips.length > 0) {
                    if (selectedIndex) {
                        select(paySlipStore.paySlips[selectedIndex]);
                    } else {
                        select(paySlipStore.paySlips[0]);
                    }
                }


            }).finally(() => {
                loading.value = false;
            })
        }

        function addHeaderHead() {
            headers.value.push(
                {
                    text: $i18n.t("common.code"),
                    align: "start",
                    sortable: true,
                    value: "workerCode",
                    ordre: -7,
                },
                {
                    text: $i18n.t("common.last_name"),
                    align: "start",
                    sortable: true,
                    value: "workerLastName",
                    ordre: -6,
                },
                {
                    text: $i18n.t("common.first_name"),
                    align: "start",
                    sortable: true,
                    value: "workerFirstName",
                    ordre: -5,
                },
                {
                    text: $i18n.t("module.occupation"),
                    align: "start",
                    sortable: true,
                    value: "workerOccupationName",
                    ordre: -4,
                },
                {
                    text: $i18n.t("module.organizational_chart"),
                    align: "start",
                    sortable: true,
                    value: "workerOrganizationalChartName",
                    ordre: -3,
                },
                {
                    text: $i18n.t("common.grille"),
                    align: "start",
                    sortable: true,
                    value: "grille",
                    order: -2,
                }
            );
        }

        function addHeader(detail) {
            if (!headers.value.some((header) => header.value === detail.code)) {
                headers.value.push({
                    text: detail.label,
                    align: "center",
                    sortable: false,
                    value: detail.code,
                    ordre: detail.ordre + 7,
                });
            }
        }

        function addFooterHeader() {
            headers.value.push(
                {
                    text: $i18n.t("common.base_imposable"),
                    align: "start",
                    sortable: true,
                    value: "baseImposable",
                    ordre: 3000,
                },
                {
                    text: $i18n.t("common.base_cotisable"),
                    align: "start",
                    sortable: true,
                    value: "baseCotisable",
                    ordre: 3001,
                },
                {
                    text: $i18n.t("pay_section.total_gains"),
                    align: "start",
                    sortable: true,
                    value: "totalGains",
                    ordre: 3002,
                },
                {
                    text: $i18n.t("pay_section.total_retenues"),
                    align: "start",
                    sortable: true,
                    value: "totalRetenues",
                    ordre: 3002,
                },
                {
                    text: $i18n.t("common.net"),
                    align: "start",
                    sortable: true,
                    value: "net",
                    ordre: 3003,
                },
                {
                    text: "Total CNAS",
                    align: "start",
                    sortable: true,
                    value: "totalCnas",
                    ordre: 3011,
                },
                {
                    text: $i18n.t("pay_slip.masse"),
                    align: "start",
                    sortable: true,
                    value: "masse",
                    ordre: 3012,
                }
            );
        }

        function select(item) {
            selectedOne.value = item;
        }

        function rowColor(item) {
            if (selectedOne.value.workerCode === item.workerCode)
                return itemColor.value;
        }

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true});

        watch(() => page.value, () => {
            select(paySlipStore.paySlips[(page.value - 1) * itemsPerPage.value]);
        });

        onMounted(() => findAll());

        return {
            paySlipStore,
            filter,
            loading,
            rightDrawer,
            page,
            itemsPerPage,
            pageCount,
            paginationListLength,
            total,
            headers,
            selected,
            selectedOne,
            findAll,
            rowColor,
            select,
            clearFilter,
            priceFormat
        }
    },
}
</script>

<style scoped>

</style>